module.exports = __webpack_public_path__ + "images/08-06@2x_cfd025f1.png";